module.exports = __webpack_public_path__ + "static/media/15.f1b7e3db.svg";